import axios from "../axios"
import { AxiosResponse } from "axios"

export function queryExceptions(params: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/exceptions`, {
        params: params
    })
}